<template>
  <index ref="index"
         :hidePage="hidePage"
         :menuList="$store.state.menuList"
         :keyword="keyword"
         :subMenuList="subMenuList"
         :route="route"
         :icon="icon"
         v-bind="$attrs"
         @onWidthChange="onWidthChange"
         @onsetCurrentMenu="onsetCurrentMenu"
  ></index>

</template>
<script>
import index from '@/components/sidebar/index'

export default {
  name: "sidebar",
  components: {index},
  data: () => ({
      //唯一标识 默认module_int 可不传
      keyword:"module_int",
      //三级菜单列表key 默认 subMenuList 可不传
      subMenuList:'subMenuList',
      //跳转页面URL key 默认 module_es 可不传
      route:"module_es",
      //icon key  默认 module_es 可不传
      icon:"module_icon",
      //不显示侧边栏的页面
      hidePage: ['/home', '/user/my-upload', '/user/my-download', '/user/center']

    }
  ),
  methods:{
    //初始化
    init(){
        this.$refs.index.init();
    },
    //侧边栏宽度变更
    onWidthChange(bool){
      this.$store.commit('setCollapsed', bool);
    },
    //当前是否有二级菜单数据并且显示已经菜单
    onsetCurrentMenu(bool){
      this.$store.commit('setCurrentMenu', bool);
    },
    //显示一级菜单
    showMenu(){
      this.$refs.index.showMenu();
    }
  }
}
</script>
<style lang="less" scoped>

@import url('~@/assets/style/variable.less');


</style>